import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import LanguageDropdown from "./LanguageDropdown";
import VersionInfo from "./VersionInfo";


export default function AuthLayout() {
  const { t } = useTranslation();
  return (
    <main className="bg-bluelight md:bg-white  py-10 min-h-[calc(100vh-5px)] md:py-10 md:pt-0 md:px-0 relative px-4 flex flex-col justify-between lg:justify-normal">
      {/* mobile top section start */}
      <div className="relative hidden md:flex  items-end justify-center md:bg-[url(/public/assets/images/mobileposter.png)] bg-no-repeat bg-bottom bg-cover h-[250px] w-full">
        <div className="md:flex hidden">
          <img
            src="/assets/images/whitelogo.png"
            alt="Zubrius"
            className="w-[132px] absolute top-10"
          />
          <img
            src="/assets/images/Zubrius.png"
            alt="Zubrius"
            className="-mb-5"
          />
        </div>
      </div>
      {/* mobile top section start */}

      {/* Desktop top section start */}
      <img
        src="/assets/images/LOGO.png"
        alt="zubrus logo"
        className="mx-auto md:hidden flex"
      />
      {/* Desktop top section end */}

      {/* login section */}
      <Outlet />
      <div className="absolute bottom-1 right-1 z-[99]">
        <LanguageDropdown />
      </div>
      {/* copyright section */}
      <div className="px-5 flex items-center justify-between">
        <span className="regular-text text-lightgray">{t("copyright")}</span>
        <VersionInfo />
      </div>
    </main>
  );
}
